import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'
import { FetchActionsWith } from '@typings/generic'

export const moduleName = 'productStocks'

const fetchModule = createFetchModule('@store/Stocks', 'LOAD', moduleName)
const loadList = createFetchSubmodule('@store/Stocks', 'LOAD_LIST', moduleName)
const exportStocksSubmodule = createFetchSubmodule('@store/Stocks', 'EXPORT', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
  export: exportStocksSubmodule.actionTypes,
  loadList: loadList.actionTypes,
}

export default reduceReducers(fetchModule.reducer, loadList.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  export: exportStocksSubmodule.actions.run,
  loadList: loadList.actions.run,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
  ...loadList.selectors,
}
